import { useEffect } from "react";

const BASE = "https://getcerty.co.uk";

export default function useSeo({ title, description, path, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (sel, attr, val) => { let el = document.head.querySelector(sel); if (!el) { el = document.createElement(sel.startsWith("link") ? "link" : "meta"); const [k, v] = sel.match(/\[(.+?)="(.+?)"\]/).slice(1); el.setAttribute(k, v); document.head.appendChild(el); } el.setAttribute(attr, val); };
    if (description) { set('meta[name="description"]', "content", description); set('meta[property="og:description"]', "content", description); }
    if (title) set('meta[property="og:title"]', "content", title);
    if (path !== undefined) { set('link[rel="canonical"]', "href", BASE + path); set('meta[property="og:url"]', "content", BASE + path); }
    let s;
    if (jsonLd) { s = document.createElement("script"); s.type = "application/ld+json"; s.textContent = JSON.stringify(jsonLd); document.head.appendChild(s); }
    return () => { if (s) s.remove(); };
  }, [title, description, path, JSON.stringify(jsonLd)]); // eslint-disable-line
}
